module.exports = __webpack_public_path__ + "public/img/xxw_qr.9861138e.jpg";